{
  "child-option": {
    "en": "[0]'s Option",
    "ar": "[0] خيار",
    "id": "Pilihan Sub"
  },
  "empty-message": {
    "en": "No messages",
    "ar": "لا يوجد رسائل",
    "id": "Tidak ada pesan"
  },
  "empty-message-desc": {
    "en": "You have no messages yet",
    "ar": "لا يوجد رسائل",
    "id": "Tidak ada pesan"
  },
  "upgrade-title": {
    "en": "Upgrade",
    "ar": "ترقية",
    "id": "Upgrade"
  },
  "upgrade-description": {
    "en": "Upgrade your account to get more features",
    "ar": "ترقية حسابك للاستفادة من المزيد من الميزات",
    "id": "Upgrade your account to get more features"
  },
  "free": {
    "en": "Free",
    "ar": "مجانا",
    "id": "Gratis"
  },
  "at-least-one-image": {
    "en": "At least one image is required",
    "ar": "يجب وجود صورة",
    "id": "Minimal satu gambar"
  },
  "currency-empty": {
    "en": "Currency is required",
    "ar": "يجب اختيار العملة",
    "id": "Pilih Mata Uang"
  },
  "select-currency": {
    "en": "Select Currency",
    "ar": "اختر العملة",
    "id": "Pilih Mata Uang"
  },
  "select-state": {
    "en": "Select State",
    "ar": "اختر الولاية",
    "id": "Pilih Provinsi"
  },
  "select-city": {
    "en": "Select City",
    "ar": "اختر المدينة",
    "id": "Pilih Kota"
  },
  "select-ad-type": {
    "en": "Select Ad Type",
    "ar": "اختر نوع الإعلان",
    "id": "Pilih Tipe Iklan"
  },
  "edit": {
    "en": "Edit",
    "ar": "تعديل",
    "id": "Ubah"
  },
  "delete-post": {
    "en": "Delete",
    "ar": "حذف",
    "id": "Hapus"
  },
  "view": {
    "en": "View",
    "ar": "عرض",
    "id": "Lihat"
  },
  "type": {
    "en": "Type",
    "ar": "نوع",
    "id": "Tipe"
  },
  "select-sub-category": {
    "en": "Select Sub Category",
    "ar": "اختر التصنيف الفرعي",
    "id": "Pilih Sub Kategori"
  },
  "select-category": {
    "en": "Select Category",
    "ar": "اختر التصنيف",
    "id": "Pilih Kategori"
  },
  "total-ads": {
    "en": "Total Ads",
    "ar": "إجمالي الإعلانات",
    "id": "Total Iklan"
  },
  "ad-created": {
    "en": "Ad Created",
    "ar": "تم إنشاء الإعلان",
    "id": "Iklan Dicipta"
  },
  "ad-created-description": {
    "en": "Your ad has been created successfully",
    "ar": "تم إنشاء الإعلان بنجاح",
    "id": "Iklan Anda berhasil dicipta"
  },
  "ad-updated": {
    "en": "Ad Updated",
    "ar": "تم تحديث الإعلان",
    "id": "Iklan Diperbarui"
  },
  "ad-updated-description": {
    "en": "Your ad has been updated successfully",
    "ar": "تم تحديث الإعلان بنجاح",
    "id": "Iklan Anda berhasil diperbarui"
  },
  "ok-got-it": {
    "en": "Ok Got It",
    "ar": "حسناً",
    "id": "Baik"
  },
  "setting": {
    "en": "Setting",
    "ar": "الإعدادات",
    "id": "Pengaturan"
  },
  "upload-photo": {
    "en": "Upload Photo",
    "ar": "رفع صورة",
    "id": "Unggah Foto"
  },
  "edit-cover": {
    "en": "Edit Cover",
    "ar": "تعديل الغلاف",
    "id": "Ubah Cover"
  },
  "ad-type": {
    "en": "Ad Type",
    "ar": "نوع الإعلان",
    "id": "Tipe Iklan"
  },
  "state": {
    "en": "Governorate",
    "ar": " المحافظة",
    "id": "Provinsi"
  },
  "city": {
    "en": "City",
    "ar": " المدينة",
    "id": "Kota"
  },
  "name": {
    "en": "Name",
    "ar": "الاسم",
    "id": "Nama"
  },
  "phone-number": {
    "en": "Phone Number",
    "ar": "رقم الهاتف",
    "id": "Nomor Telepon"
  },
  "email": {
    "en": "Email",
    "ar": "البريد الإلكتروني",
    "id": "Email"
  },
  "update-info": {
    "en": "Update Info",
    "ar": "تحديث المعلومات",
    "id": "Perbarui Profil"
  },
  "change-password": {
    "en": "Change Password",
    "ar": "تغيير كلمة المرور",
    "id": "Ubah Kata Sandi"
  },
  "current-package": {
    "en": "Current Package",
    "ar": "الحزمة الحالية",
    "id": "Paket Saat Ini"
  },
  "select-package": {
    "en": "Select Package",
    "ar": "اختر الحزمة",
    "id": "Pilih Paket"
  },
  "subscribe": {
    "en": "Subscribe",
    "ar": "الاشتراك",
    "id": "Langganan"
  },
  "privacy": {
    "en": "Privacy",
    "ar": "الخصوصية",
    "id": "Privasi"
  },
  "terms": {
    "en": "Terms & Conditions",
    "ar": "الشروط والأحكام",
    "id": "Syarat & Ketentuan"
  },
  "faq": {
    "en": "FAQ",
    "ar": "الأسئلة الشائعة",
    "id": "FAQ"
  },
  "delete": {
    "en": "Delete Account",
    "ar": "حذف الحساب",
    "id": "Hapus Akun"
  },
  "delete-title": {
    "en": "Delete Account",
    "ar": "حذف الحساب",
    "id": "Hapus Akun"
  },
  "delete-description-1": {
    "en": "Account Deactivation Process",
    "ar": "عملية إلغاء تنشيط الحساب",
    "id": "Proses Penonaktifan Akun"
  },
  "delete-description-2": {
    "en": "When you delete your account, it will be deactivated for 3 months. During this period, you can reactivate your account by simply logging in again.",
    "ar": "عند حذف حسابك، سيتم إلغاء تنشيطه لمدة 3 أشهر. خلال هذه الفترة، يمكنك إعادة تنشيط حسابك بمجرد تسجيل الدخول مرة أخرى.",
    "id": "Saat Anda menghapus akun, akun akan dinonaktifkan selama 3 bulan. Selama periode ini, Anda dapat mengaktifkan kembali akun Anda dengan masuk kembali."
  },
  "delete-description-3": {
    "en": "If you do not log in within 3 months, your account and all associated data will be permanently deleted and cannot be recovered. ⚠️",
    "ar": "إذا لم تقم بتسجيل الدخول خلال 3 أشهر، فسيتم حذف حسابك وجميع البيانات المرتبطة به بشكل دائم ولا يمكن استردادها. ⚠️",
    "id": "Jika Anda tidak masuk dalam waktu 3 bulan, akun dan semua data terkait akan dihapus secara permanen dan tidak dapat dipulihkan. ⚠️"
  },
  "delete-button": {
    "en": "Delete Account",
    "ar": "حذف الحساب",
    "id": "Hapus Akun"
  },
  "location": {
    "en": "Location",
    "ar": "الموقع",
    "id": "Lokasi"
  },
  "edit-profile": {
    "en": "Edit Profile",
    "ar": "تعديل الملف الشخصي",
    "id": "Ubah Profil"
  },
  "share-profile": {
    "en": "Share Profile",
    "ar": "مشاركة الملف الشخصي",
    "id": "Bagikan Profil"
  },
  "active-ads": {
    "en": "Active Ads",
    "ar": "الإعلانات النشطة",
    "id": "Iklan Aktif"
  },
  "sold-ads": {
    "en": "Sold Ads",
    "ar": "الإعلانات المبيعة",
    "id": "Iklan Terjual"
  },
  "approved-ads": {
    "en": "Approved Ads",
    "ar": "الإعلانات المقبولة",
    "id": "Iklan Diterima"
  },
  "rejected-ads": {
    "en": "Rejected Ads",
    "ar": "الإعلانات الرفض",
    "id": "Iklan Ditolak"
  },
  "send": {
    "en": "Send",
    "ar": "إرسال",
    "id": "Kirim"
  },
  "placeholder-message": {
    "en": "Your message",
    "ar": "رسالتك",
    "id": "Pesan Anda"
  },
  "placeholder-search": {
    "en": "Search",
    "ar": "بحث",
    "id": "Cari"
  },
  "all": {
    "en": "All",
    "ar": "الكل",
    "id": "Semua"
  },
  "approved": {
    "en": "Approved",
    "ar": "مقبولة",
    "id": "Diterima"
  },
  "rejected": {
    "en": "Rejected",
    "ar": "رفض",
    "id": "Ditolak"
  },
  "ads-still-empty": {
    "en": "Ads still Empty",
    "ar": "الإعلانات لا تزال فارغة",
    "id": "Iklan Masih Kosong"
  },
  "ads-still-empty-description": {
    "en": "It seems like you still don't have saved or created ads product",
    "ar": "يبدو أنك لا تمتلك إعلانات",
    "id": "Iklan Masih Kosong"
  },
  "add-new-ads": {
    "en": "Add New Ads",
    "ar": "إضافة إعلان جديد",
    "id": "Tambah Iklan Baru"
  },
  "status": {
    "en": "Status",
    "ar": "الحالة",
    "id": "Status"
  },
  "action": {
    "en": "Action",
    "ar": "العمليات",
    "id": "Aksi"
  },
  "details": {
    "en": "Details",
    "ar": "التفاصيل",
    "id": "Detail"
  },
  "price": {
    "en": "Price",
    "ar": "السعر",
    "id": "Harga"
  },
  "cancel": {
    "en": "Cancel",
    "ar": "إلغاء",
    "id": "Batal"
  },
  "submit-for-review": {
    "en": "Submit for review",
    "ar": "إرسال للإختبار",
    "id": "Kirim untuk Review"
  },
  "add-more-features": {
    "en": "Add more features",
    "ar": "إضافة المزيد من الميزات",
    "id": "Tambahkan Fitur Lainnya"
  },
  "ad-details": {
    "en": "Ad Details",
    "ar": "تفاصيل الإعلان",
    "id": "Detail Iklan"
  },
  "ads-name": {
    "en": "Title",
    "ar": "العنوان",
    "id": "Judul"
  },
  "placeholder-ads-name": {
    "en": "Title your ads",
    "ar": "عنوان إعلانك",
    "id": "Judul Iklan Anda"
  },
  "ads-name-ar": {
    "en": "Title (Arabic)",
    "ar": "عنوان إعلانك",
    "id": "Judul Iklan Anda (Arab)"
  },
  "placeholder-ads-name-ar": {
    "en": "Title your ads (Arabic)",
    "ar": "عنوان إعلانك",
    "id": "Judul Iklan Anda (Arab)"
  },
  "location-ar": {
    "en": "Location (Arabic)",
    "ar": "موقع",
    "id": "Lokasi (Arab)"
  },
  "placeholder-location-ar": {
    "en": "Location your listing (Arabic)",
    "ar": "موقع إعلانك",
    "id": "Lokasi Iklan Anda (Arab)"
  },
  "placeholder-location": {
    "en": "Location your listing",
    "ar": "موقع إعلانك",
    "id": "Lokasi Iklan Anda"
  },
  "placeholder-price": {
    "en": "999.9999",
    "ar": "999.9999",
    "id": "999.9999"
  },
  "category": {
    "en": "Category",
    "ar": "التصنيف",
    "id": "Kategori"
  },
  "sub-category": {
    "en": "Sub Category",
    "ar": "التصنيف الفرعي",
    "id": "Sub Kategori"
  },
  "placeholder-description": {
    "en": "Describe your listing with honest, make the caption details as good as possible!",
    "ar": "وصف إعلانك بصدق، اجعل التفاصيل ممتازة!",
    "id": "Deskripsikan iklan Anda dengan jujur, buat detail caption Anda sebaik mungkin!"
  },
  "description": {
    "en": "Description",
    "ar": "الوصف",
    "id": "Deskripsi"
  },
  "description-ar": {
    "en": "Description (Arabic)",
    "ar": "الوصف",
    "id": "Deskripsi (Arab)"
  },
  "placeholder-description-ar": {
    "en": "Describe your listing with honest, make the caption details as good as possible!",
    "ar": "وصف إعلانك بصدق، اجعل التفاصيل ممتازة!",
    "id": "Deskripsikan iklan Anda dengan jujur, buat detail caption Anda sebaik mungkin!"
  },
  "photo": {
    "en": "Photo",
    "ar": "الصورة",
    "id": "Foto"
  },
  "features": {
    "en": "Features",
    "ar": "الميزات",
    "id": "Fitur"
  },
  "placeholder-features": {
    "en": "Write listing highlight",
    "ar": "كتابة قائمة تسليط الضوء",
    "id": "Tulis fitur unggulan"
  },
  "specification": {
    "en": "Spesification",
    "ar": "الخصائص",
    "id": "Spesifikasi"
  },
  "under-review": {
    "en": "Under Review",
    "ar": "قيد المراجعة",
    "id": "Dalam Review"
  },
  "sold-out": {
    "en": "Sold Out",
    "ar": "تم البيع",
    "id": "Terjual"
  },
  "inactive": {
    "en": "Inactive",
    "ar": "غير نشط",
    "id": "Tidak Aktif"
  },
  "password": {
    "en": "Password",
    "ar": "كلمة المرور",
    "id": "Kata Sandi"
  },
  "placeholder-password": {
    "en": "Enter your password",
    "ar": "قم بادخال كلمة المرور",
    "id": "Masukkan kata sandi"
  },
  "loading": {
    "en": "Loading...",
    "ar": "جاري التحميل...",
    "id": "Loading..."
  },
  "user-not-authenticated": {
    "en": "User not authenticated",
    "ar": "المستخدم غير مصادق عليه",
    "id": "Pengguna tidak terautentikasi"
  },
  "delete-confirm-title": {
    "en": "Delete Account",
    "ar": "حذف الحساب",
    "id": "Hapus Akun"
  },
  "delete-confirm-subtitle": {
    "en": "Are you sure you want to delete your account? It will be deactivated for 3 months before permanent deletion.",
    "ar": "هل أنت متأكد من حذف حسابك؟ سيتم إلغاء تنشيطه لمدة 3 أشهر قبل الحذف الدائم.",
    "id": "Apakah Anda yakin ingin menghapus akun Anda? Akun akan dinonaktifkan selama 3 bulan sebelum penghapusan permanen."
  },
  "security-title": {
    "en": "Sign in and security",
    "ar": "تسجيل الدخول والأمان",
    "id": "Masuk dan keamanan"
  },
  "security-description": {
    "en": "Uses this information to verify your identity and to keep our community safe. You decide what personal details you make visible to others.",
    "ar": "استخدم هذه المعلومات للتحقق من هويتك وللحفاظ على سلامة مجتمعنا. أنت تقرر ما هي التفاصيل الشخصية التي تجعلها مرئية للآخرين.",
    "id": "Gunakan informasi ini untuk memverifikasi identitas Anda dan menjaga keamanan komunitas kami. Anda yang memutuskan detail pribadi apa yang ingin Anda tampilkan kepada orang lain."
  },
  "phone-number-label": {
    "en": "Phone Number",
    "ar": "رقم الهاتف",
    "id": "Nomor Telepon"
  },
  "phone-number-placeholder": {
    "en": "Enter phone number starting with +",
    "ar": "أدخل رقم الهاتف يبدأ بـ +",
    "id": "Masukkan nomor telepon dimulai dengan +"
  },
  "email-label": {
    "en": "Email",
    "ar": "البريد الإلكتروني",
    "id": "Email"
  },
  "email-placeholder": {
    "en": "Enter your email",
    "ar": "أدخل بريدك الإلكتروني",
    "id": "Masukkan email Anda"
  },
  "saving": {
    "en": "Saving...",
    "ar": "جاري الحفظ...",
    "id": "Menyimpan..."
  },
  "save": {
    "en": "Save",
    "ar": "حفظ",
    "id": "Simpan"
  },
  "save-changes": {
    "en": "Save Changes",
    "ar": "حفظ التغييرات",
    "id": "Simpan Perubahan"
  },
  "saved-empty-title": {
    "en": "No saved items yet",
    "ar": "لا توجد عناصر محفوظة حتى الآن",
    "id": "Belum ada item tersimpan"
  },
  "saved-empty-description": {
    "en": "Start saving profiles, posts, and other content to see them here. Your saved items will appear in this collection.",
    "ar": "ابدأ بحفظ الملفات الشخصية والمنشورات والمحتوى الآخر لرؤيتها هنا. ستظهر العناصر المحفوظة في هذه المجموعة.",
    "id": "Mulai menyimpan profil, postingan, dan konten lainnya untuk melihatnya di sini. Item tersimpan Anda akan muncul di koleksi ini."
  },
  "video-unsaved-success": {
    "en": "Video unsaved successfully",
    "ar": "تم إلغاء حفظ الفيديو بنجاح",
    "id": "Video berhasil dihapus dari tersimpan"
  },
  "video-unsaved-error": {
    "en": "Failed to unsave video",
    "ar": "فشل إلغاء حفظ الفيديو",
    "id": "Gagal menghapus video dari tersimpan"
  },
  "error-occurred": {
    "en": "An error occurred",
    "ar": "حدث خطأ",
    "id": "Terjadi kesalahan"
  },
  "profile-settings-title": {
    "en": "Profile Settings",
    "ar": "إعدادات الملف الشخصي",
    "id": "Pengaturan Profil"
  },
  "profile-settings-description": {
    "en": "Update your profile information",
    "ar": "تحديث معلومات ملفك الشخصي",
    "id": "Perbarui informasi profil Anda"
  },
  "full-name": {
    "en": "Full Name",
    "ar": "الاسم الكامل",
    "id": "Nama Lengkap"
  },
  "full-name-placeholder": {
    "en": "Enter your full name",
    "ar": "أدخل اسمك الكامل",
    "id": "Masukkan nama lengkap Anda"
  },
  "date-of-birth": {
    "en": "Date of Birth",
    "ar": "تاريخ الميلاد",
    "id": "Tanggal Lahir"
  },
  "about-optional": {
    "en": "About (Optional)",
    "ar": "نبذة (اختياري)",
    "id": "Tentang (Opsional)"
  },
  "about-placeholder": {
    "en": "Tell us about yourself...",
    "ar": "أخبرنا عن نفسك...",
    "id": "Ceritakan tentang diri Anda..."
  },
  "occupation-optional": {
    "en": "Occupation (Optional)",
    "ar": "المهنة (اختياري)",
    "id": "Pekerjaan (Opsional)"
  },
  "occupation-placeholder": {
    "en": "Ex: Software Engineer",
    "ar": "مثال: مهندس برمجيات",
    "id": "Contoh: Software Engineer"
  },
  "open-to-work": {
    "en": "I am open to work opportunities",
    "ar": "أنا مستعد لفرص العمل",
    "id": "Saya terbuka untuk peluang kerja"
  },
  "open-to-work-description": {
    "en": "This will show your availability status to others",
    "ar": "سيظهر هذا حالة توفرك للآخرين",
    "id": "Ini akan menunjukkan status ketersediaan Anda kepada orang lain"
  },
  "profile-updated-success": {
    "en": "Profile updated successfully",
    "ar": "تم تحديث الملف الشخصي بنجاح",
    "id": "Profil berhasil diperbarui"
  },
  "jobs-title": {
    "en": "Job Candidates",
    "ar": "مرشحو الوظائف",
    "id": "Kandidat Pekerjaan"
  },
  "jobs-description": {
    "en": "Select a job to view its candidates",
    "ar": "اختر وظيفة لعرض مرشحيها",
    "id": "Pilih pekerjaan untuk melihat kandidatnya"
  },
  "jobs-empty-title": {
    "en": "No jobs posted yet",
    "ar": "لم يتم نشر أي وظائف بعد",
    "id": "Belum ada lowongan yang diposting"
  },
  "jobs-empty-description": {
    "en": "Create a job posting to start receiving candidates.",
    "ar": "أنشئ إعلان وظيفة للبدء في استقبال المرشحين.",
    "id": "Buat lowongan pekerjaan untuk mulai menerima kandidat."
  },
  "delete-job-title": {
    "en": "Delete Job",
    "ar": "حذف الوظيفة",
    "id": "Hapus Lowongan"
  },
  "delete-job-subtitle": {
    "en": "Are you sure you want to delete this job posting? This action cannot be undone.",
    "ar": "هل أنت متأكد من حذف إعلان الوظيفة هذا؟ لا يمكن التراجع عن هذا الإجراء.",
    "id": "Apakah Anda yakin ingin menghapus lowongan ini? Tindakan ini tidak dapat dibatalkan."
  },
  "view-details": {
    "en": "View Details",
    "ar": "عرض التفاصيل",
    "id": "Lihat Detail"
  },
  "update": {
    "en": "Update",
    "ar": "تحديث",
    "id": "Perbarui"
  },
  "update-job": {
    "en": "Update Job",
    "ar": "تحديث الوظيفة",
    "id": "Perbarui Lowongan"
  },
  "job-title-label": {
    "en": "Job Title",
    "ar": "المسمى الوظيفي",
    "id": "Judul Pekerjaan"
  },
  "job-title-placeholder": {
    "en": "Enter job title",
    "ar": "أدخل المسمى الوظيفي",
    "id": "Masukkan judul pekerjaan"
  },
  "salary-range-start": {
    "en": "Salary Range Start",
    "ar": "بداية نطاق الراتب",
    "id": "Rentang Gaji Awal"
  },
  "salary-range-end": {
    "en": "Salary Range End",
    "ar": "نهاية نطاق الراتب",
    "id": "Rentang Gaji Akhir"
  },
  "location-label": {
    "en": "Location",
    "ar": "الموقع",
    "id": "Lokasi"
  },
  "location-placeholder": {
    "en": "Enter location",
    "ar": "أدخل الموقع",
    "id": "Masukkan lokasi"
  },
  "employment-type": {
    "en": "Employment Type",
    "ar": "نوع التوظيف",
    "id": "Jenis Pekerjaan"
  },
  "select-type": {
    "en": "Select type",
    "ar": "اختر النوع",
    "id": "Pilih jenis"
  },
  "full-time": {
    "en": "Full-time",
    "ar": "دوام كامل",
    "id": "Penuh waktu"
  },
  "part-time": {
    "en": "Part-time",
    "ar": "دوام جزئي",
    "id": "Paruh waktu"
  },
  "contract": {
    "en": "Contract",
    "ar": "عقد",
    "id": "Kontrak"
  },
  "internship": {
    "en": "Internship",
    "ar": "تدريب",
    "id": "Magang"
  },
  "work-arrangement": {
    "en": "Work Arrangement",
    "ar": "ترتيب العمل",
    "id": "Pengaturan Kerja"
  },
  "select-arrangement": {
    "en": "Select arrangement",
    "ar": "اختر الترتيب",
    "id": "Pilih pengaturan"
  },
  "on-site": {
    "en": "On-site",
    "ar": "في الموقع",
    "id": "Di tempat"
  },
  "remote": {
    "en": "Remote",
    "ar": "عن بعد",
    "id": "Jarak jauh"
  },
  "hybrid": {
    "en": "Hybrid",
    "ar": "هجين",
    "id": "Hibrida"
  },
  "requirements-label": {
    "en": "Requirements",
    "ar": "المتطلبات",
    "id": "Persyaratan"
  },
  "requirements-placeholder": {
    "en": "Enter job requirements",
    "ar": "أدخل متطلبات الوظيفة",
    "id": "Masukkan persyaratan pekerjaan"
  },
  "back-to-jobs": {
    "en": "Back to Jobs",
    "ar": "العودة إلى الوظائف",
    "id": "Kembali ke Lowongan"
  },
  "candidates": {
    "en": "Candidates",
    "ar": "المرشحون",
    "id": "Kandidat"
  },
  "candidate-applied": {
    "en": "candidate applied",
    "ar": "مرشح قدم طلبه",
    "id": "kandidat melamar"
  },
  "candidates-applied": {
    "en": "candidates applied",
    "ar": "مرشحون قدموا طلباتهم",
    "id": "kandidat melamar"
  },
  "no-candidates-yet": {
    "en": "No candidates yet",
    "ar": "لا يوجد مرشحون بعد",
    "id": "Belum ada kandidat"
  },
  "no-candidates-description": {
    "en": "Candidates who apply for this job will appear here.",
    "ar": "سيظهر هنا المرشحون الذين يتقدمون لهذه الوظيفة.",
    "id": "Kandidat yang melamar pekerjaan ini akan muncul di sini."
  },
  "no-occupation": {
    "en": "No occupation",
    "ar": "لا توجد مهنة",
    "id": "Tidak ada pekerjaan"
  },
  "applied-on": {
    "en": "Applied on",
    "ar": "قدم طلبه في",
    "id": "Melamar pada"
  },
  "profile": {
    "en": "Profile",
    "ar": "الملف الشخصي",
    "id": "Profil"
  },
  "back-to-candidates": {
    "en": "Back to Candidates",
    "ar": "العودة إلى المرشحين",
    "id": "Kembali ke Kandidat"
  },
  "failed-load-candidate": {
    "en": "Failed to load candidate details",
    "ar": "فشل تحميل تفاصيل المرشح",
    "id": "Gagal memuat detail kandidat"
  },
  "applied-job": {
    "en": "Applied Job",
    "ar": "الوظيفة المتقدم لها",
    "id": "Pekerjaan yang Dilamar"
  },
  "expected-salary": {
    "en": "Expected Salary",
    "ar": "الراتب المتوقع",
    "id": "Gaji yang Diharapkan"
  },
  "cover-letter": {
    "en": "Comments",
    "ar": "خطاب التقديم",
    "id": "Surat Lamaran"
  },
  "submitted-tasks": {
    "en": "Submitted Tasks",
    "ar": "المهام المقدمة",
    "id": "Tugas yang Dikirim"
  },
  "request-interview": {
    "en": "Request Interview",
    "ar": "طلب مقابلة",
    "id": "Minta Wawancara"
  },
  "add-to-compare": {
    "en": "Add to Compare",
    "ar": "إضافة للمقارنة",
    "id": "Tambah ke Perbandingan"
  },
  "added-to-compare-success": {
    "en": "added to",
    "ar": "أضيف إلى",
    "id": "ditambahkan ke"
  },
  "successfully": {
    "en": "successfully",
    "ar": "بنجاح",
    "id": "berhasil"
  },
  "update-profile-picture": {
    "en": "Update Profile Picture",
    "ar": "تحديث صورة الملف الشخصي",
    "id": "Perbarui Foto Profil"
  },
  "update-profile-picture-description": {
    "en": "Upload a new profile picture to personalize your account",
    "ar": "قم بتحميل صورة ملف شخصي جديدة لتخصيص حسابك",
    "id": "Unggah foto profil baru untuk mempersonalisasi akun Anda"
  },
  "upload-new-picture": {
    "en": "Upload New Picture",
    "ar": "تحميل صورة جديدة",
    "id": "Unggah Foto Baru"
  },
  "upload-formats-description": {
    "en": "Choose a new profile picture. Supported formats: JPG, PNG, GIF (max 5MB)",
    "ar": "اختر صورة ملف شخصي جديدة. الصيغ المدعومة: JPG, PNG, GIF (حد أقصى 5 ميجابايت)",
    "id": "Pilih foto profil baru. Format yang didukung: JPG, PNG, GIF (maks 5MB)"
  },
  "select-image-file": {
    "en": "Please select an image file",
    "ar": "الرجاء اختيار ملف صورة",
    "id": "Silakan pilih file gambar"
  },
  "file-size-limit": {
    "en": "File size must be less than 5MB",
    "ar": "يجب أن يكون حجم الملف أقل من 5 ميجابايت",
    "id": "Ukuran file harus kurang dari 5MB"
  },
  "select-file-to-upload": {
    "en": "Please select a file to upload",
    "ar": "الرجاء اختيار ملف للتحميل",
    "id": "Silakan pilih file untuk diunggah"
  },
  "profile-picture-updated": {
    "en": "Profile picture updated successfully",
    "ar": "تم تحديث صورة الملف الشخصي بنجاح",
    "id": "Foto profil berhasil diperbarui"
  },
  "profile-picture-update-failed": {
    "en": "Failed to update profile picture",
    "ar": "فشل تحديث صورة الملف الشخصي",
    "id": "Gagal memperbarui foto profil"
  },
  "profile-picture-update-error": {
    "en": "An error occurred while updating your profile picture",
    "ar": "حدث خطأ أثناء تحديث صورة ملفك الشخصي",
    "id": "Terjadi kesalahan saat memperbarui foto profil Anda"
  },
  "click-different-file": {
    "en": "Click to choose a different file or drag and drop here",
    "ar": "انقر لاختيار ملف مختلف أو اسحب وأفلت هنا",
    "id": "Klik untuk memilih file lain atau seret dan lepas di sini"
  },
  "drop-image-here": {
    "en": "Drop your image here, or click to browse",
    "ar": "أفلت صورتك هنا، أو انقر للتصفح",
    "id": "Letakkan gambar Anda di sini, atau klik untuk menelusuri"
  },
  "file-formats-limit": {
    "en": "JPG, PNG, GIF up to 5MB",
    "ar": "JPG, PNG, GIF حتى 5 ميجابايت",
    "id": "JPG, PNG, GIF hingga 5MB"
  },
  "clear": {
    "en": "Clear",
    "ar": "مسح",
    "id": "Hapus"
  },
  "uploading": {
    "en": "Uploading...",
    "ar": "جاري التحميل...",
    "id": "Mengunggah..."
  },
  "update-picture": {
    "en": "Update Picture",
    "ar": "تحديث الصورة",
    "id": "Perbarui Foto"
  },
  "availability-settings": {
    "en": "Availability Settings",
    "ar": "إعدادات التوفر",
    "id": "Pengaturan Ketersediaan"
  },
  "availability-description": {
    "en": "Set your available time slots for interviews",
    "ar": "حدد أوقات التوفر الخاصة بك للمقابلات",
    "id": "Atur slot waktu ketersediaan Anda untuk wawancara"
  },
  "time-zone": {
    "en": "Time Zone",
    "ar": "المنطقة الزمنية",
    "id": "Zona Waktu"
  },
  "select-timezone": {
    "en": "Select your timezone",
    "ar": "اختر منطقتك الزمنية",
    "id": "Pilih zona waktu Anda"
  },
  "availability-mode": {
    "en": "Availability Mode",
    "ar": "وضع التوفر",
    "id": "Mode Ketersediaan"
  },
  "fixed-schedule": {
    "en": "Fixed Schedule",
    "ar": "جدول ثابت",
    "id": "Jadwal Tetap"
  },
  "custom-schedule": {
    "en": "Custom Schedule",
    "ar": "جدول مخصص",
    "id": "Jadwal Kustom"
  },
  "fixed-schedule-description": {
    "en": "Select days and set the same time slots for all selected days",
    "ar": "حدد الأيام وعيّن نفس الفترات الزمنية لجميع الأيام المحددة",
    "id": "Pilih hari dan atur slot waktu yang sama untuk semua hari yang dipilih"
  },
  "custom-schedule-description": {
    "en": "Set different time slots for each day individually",
    "ar": "عيّن فترات زمنية مختلفة لكل يوم على حدة",
    "id": "Atur slot waktu berbeda untuk setiap hari secara individual"
  },
  "select-days": {
    "en": "Select Days",
    "ar": "اختر الأيام",
    "id": "Pilih Hari"
  },
  "time-slots-all-days": {
    "en": "Time Slots (Applied to all selected days)",
    "ar": "الفترات الزمنية (تُطبق على جميع الأيام المحددة)",
    "id": "Slot Waktu (Diterapkan ke semua hari yang dipilih)"
  },
  "weekly-availability": {
    "en": "Weekly Availability",
    "ar": "التوفر الأسبوعي",
    "id": "Ketersediaan Mingguan"
  },
  "sunday": {
    "en": "Sunday",
    "ar": "الأحد",
    "id": "Minggu"
  },
  "monday": {
    "en": "Monday",
    "ar": "الاثنين",
    "id": "Senin"
  },
  "tuesday": {
    "en": "Tuesday",
    "ar": "الثلاثاء",
    "id": "Selasa"
  },
  "wednesday": {
    "en": "Wednesday",
    "ar": "الأربعاء",
    "id": "Rabu"
  },
  "thursday": {
    "en": "Thursday",
    "ar": "الخميس",
    "id": "Kamis"
  },
  "friday": {
    "en": "Friday",
    "ar": "الجمعة",
    "id": "Jumat"
  },
  "saturday": {
    "en": "Saturday",
    "ar": "السبت",
    "id": "Sabtu"
  },
  "availability-updated": {
    "en": "Availability updated successfully",
    "ar": "تم تحديث التوفر بنجاح",
    "id": "Ketersediaan berhasil diperbarui"
  },
  "availability-update-failed": {
    "en": "Availability update failed",
    "ar": "فشل تحديث التوفر",
    "id": "Gagal memperbarui ketersediaan"
  },
  "available-time-slots": {
    "en": "Available Time Slots",
    "ar": "الفترات الزمنية المتاحة",
    "id": "Slot Waktu Tersedia"
  },
  "confirm-delete-title": {
    "en": "Are you absolutely sure?",
    "ar": "هل أنت متأكد تماماً؟",
    "id": "Apakah Anda benar-benar yakin?"
  },
  "confirm-delete-subtitle": {
    "en": "This action cannot be undone. This will permanently delete the resource and remove your data from our servers.",
    "ar": "لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف المورد نهائياً وإزالة بياناتك من خوادمنا.",
    "id": "Tindakan ini tidak dapat dibatalkan. Ini akan menghapus sumber daya secara permanen dan menghapus data Anda dari server kami."
  },
  "confirm-delete": {
    "en": "Confirm Delete",
    "ar": "تأكيد الحذف",
    "id": "Konfirmasi Hapus"
  },
  "projects": {
    "en": "Projects",
    "ar": "المشاريع",
    "id": "Proyek"
  },
  "no-projects-available": {
    "en": "No projects available",
    "ar": "لا توجد مشاريع متاحة",
    "id": "Tidak ada proyek tersedia"
  },
  "present": {
    "en": "Present",
    "ar": "الحالي",
    "id": "Sekarang"
  },
  "view-project": {
    "en": "View Project",
    "ar": "عرض المشروع",
    "id": "Lihat Proyek"
  },
  "images": {
    "en": "Images",
    "ar": "الصور",
    "id": "Gambar"
  },
  "videos": {
    "en": "Videos",
    "ar": "الفيديوهات",
    "id": "Video"
  },
  "documents": {
    "en": "Documents",
    "ar": "المستندات",
    "id": "Dokumen"
  },
  "watch-video": {
    "en": "View Candidates",
    "ar": "مشاهدة الفيديو",
    "id": "Tonton Video"
  },
  "share": {
    "en": "Share",
    "ar": "مشاركة",
    "id": "Bagikan"
  },
  "share-job": {
    "en": "Share Job",
    "ar": "مشاركة الوظيفة",
    "id": "Bagikan Lowongan"
  },
  "share-job-description": {
    "en": "Share this job posting with others.",
    "ar": "شارك هذا الإعلان الوظيفي مع الآخرين.",
    "id": "Bagikan lowongan ini kepada orang lain."
  },
  "copy-link": {
    "en": "Copy Link",
    "ar": "نسخ الرابط",
    "id": "Salin Tautan"
  },
  "copied": {
    "en": "Copied!",
    "ar": "تم النسخ!",
    "id": "Tersalin!"
  },
  "open-new-tab": {
    "en": "Open in New Tab",
    "ar": "فتح في علامة تبويب جديدة",
    "id": "Buka di Tab Baru"
  },
  "share-via": {
    "en": "Share via...",
    "ar": "مشاركة عبر...",
    "id": "Bagikan melalui..."
  },
  "share-jobs": {
    "en": "Share Jobs",
    "ar": "مشاركة الوظائف",
    "id": "Bagikan Lowongan"
  },
  "share-jobs-description": {
    "en": "Share your job listings with others.",
    "ar": "شارك قائمة وظائفك مع الآخرين.",
    "id": "Bagikan daftar lowongan Anda kepada orang lain."
  }
}
